import accounting from 'accounting-js';
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

export function checkPasswordStrength(value = '') {
    let level = 0;
    if (value.match(/[a-z]/g)) {
      level++;
    }
    if (value.match(/[A-Z]/g)) {
      level++;
    }
    if (value.match(/[\d]/g)) {
      level++;
    }
    if (value.length >= 8) {
      level++;
    }
    return level;
  }

  
export function getCardTitle(name) {
    let title = '';
    switch (name) {
        case 'totalRebateEstimated':
            title = 'Total Rebate';
            break;
        case 'QuaterlyFlat':
            title = 'Quarterly Flat';
            break;
        case 'Special_Promo':
            title = 'Special Promo';
            break;
        case 'AnnualGroupGrowth':
            title = 'Annual Group Growth';
            break;
        case 'AnnualIndividualGrowth':
            title = 'Annual Individual Growth';
            break;
        case 'Prime_Time':
            title = 'Prime Time';
            break;
        case 'AnnualGroupFlat':
            title = 'Annual Group Flat';
            break;
        case 'AnnualIndividualFlat':
            title = 'Annual Individual Flat';
            break;
        case 'QuarterlyGroupincentives':
            title = 'Quarterly Group Incentives';
            break;
        case 'QuarterlyIndividualIncentive':
            title = 'Quarterly Individual Incentive';
            break;
        case 'potentialPurchase':
            title = 'Potential Volume';
            break;
        case 'BuyBlue':
            title = 'Buy Blue';
            break;
        case 'Member Purchase':
            title = 'Member Volume';
            break;
        case 'Purchase - VP Transaction Data':
            title = 'Volume - VP Transaction Data';
            break;
        case 'salesOpportunity':
            title = 'Sales Opportunity';
            break;
        case 'potentialRebate':
            title = 'Potential Rebate Estimated';
            break;
        case 'rebateOpportunity':
            title = 'Rebate Opportunity';
            break;
        case 'VP 1 - Quarterly Flat':
            title = 'Quarterly Flat';
            break;
        case 'VP 1 - Quarterly Individual Incentive':
            title = 'Quarterly Individual Incentive';
            break;
        case 'VP 1 - Annual Individual Incentive':
            title = 'Annual Individual Incentive';
            break;
        case 'VP 1 - Conversion':
            title = 'Conversion';
            break;
        case 'VP 1 - Special Promo':
            title = 'Special Promo';
            break;
        case 'BhTotalSales':
            title = 'BH Total Sales';
            break;
        case 'VpTotalSales':
            title = 'VP Total Sales';
            break;
        case 'BhTotalRebate':
            title = 'BH Total Rebate';
            break;
        case 'BpTotalRebate':
            title = 'VP Total Rebate';
            break;
        case 1:
            title = 'Rebate 1';
            break;
        case 2:
            title = 'Rebate 2';
            break;
        case 3:
            title = 'Rebate 3';
            break;
        case 4:
            title = 'Rebate 4';
            break;
        case 5:
            title = 'Rebate 5';
            break;
        case 6:
            title = 'Rebate 6';
            break;
        case 7:
            title = 'Rebate 7';
            break;
        case 8:
            title = 'Rebate 8';
            break;
        case 9:
            title = 'Rebate 9';
            break;
        case 10:
            title = 'Rebate 10';
            break;

        default:
            title = name;
    }
    return title;
}

export function checkIfTokenIsPresent(){
    if(localStorage.hasOwnProperty('imark-token')){
        if(localStorage.getItem('imark-token')!=="undefined"){
            return true;
        }
        return false;
    }else{
        return false;
    }
}


export function formatCurrency(value) {
    return (
        value ? <span className={value < 0 ? 'text-danger' : ''}>
            {Number(value).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })}
        </span> : <span className="text-muted">-</span>
    );
}

export function formatCurrencyToPercent(value) {
    let criteriaValue = value;
    criteriaValue = criteriaValue / 100;
    return (
        criteriaValue ? <span className={value < 0 ? 'text-danger' : ''}>
            {criteriaValue.toLocaleString('en-US', {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            })}
        </span> : <span className="text-muted">-</span>
    );
}
export function formatPounds(value) {
    return (
        value ? <span className={value < 0 ? 'text-danger' : ''}>
            {Number(value).toLocaleString('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }) + ' lbs'}
        </span> : <span className="text-muted">-</span>
    );
}

export function formatUnits(value) {
    return (
        value ? <span className={value < 0 ? 'text-danger' : ''}>
            {Number(value).toLocaleString('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }) + ' units'}
        </span> : <span className="text-muted">-</span>
    );
}

export function RvRenderMultipleVolumeCell(cell, multipleCol, criteriaCol) {
    
    return (
      <React.Fragment>
        <div className='multipleCell'>
          {cell.rowData[multipleCol]
            ? cell.rowData[multipleCol].map((value, index) => {
  
              if (cell.rowData[criteriaCol]) {
                let criteriaName = cell.rowData[criteriaCol][index];
  
                if (criteriaName) {
                  if (criteriaName.search('Sales') >= 0) {
                    return <div className='py-2 d-block'>{formatCurrency(value)}</div>;
                  } else if (criteriaName.search('Pounds') >= 0) {
                    return <div className='py-2 d-block'>{formatPounds(value)}</div>;
                  } else if (criteriaName.search('Units') >= 0) {
                    return <div className='py-2 d-block'>{formatUnits(value)}</div>;
                  } else {
                    return <div className='py-2 d-block'>{value}</div>;
                  }
                } else {
  
                  return <div className='py-2 d-block'>{value}</div>;
                }
              } else {
                return <div className='py-2 d-block'>{value}</div>;
              }
              
            })
            
            : ''}
        </div>
        
      </React.Fragment>
      
    );
  }

export function PriceFormatter(cell, row) {
    if(cell == undefined)
    return(
        "$0"
    )
    else{
    let str =  accounting.formatMoney(cell);
    str=str.slice(0,-3);
    return (
        str
    )
    }
}

export const dateFormatter = (date) => {
    return date && new Date(date).toLocaleString('en-US').split(',')[0];
}

export function PriceFormatter2(cell, row) {
    if(cell == undefined)
    return(
        "$0"
    )
    else{
    let str =  accounting.formatMoney(cell);
//str=str.slice(0,-0);
    return (
        str
    )
    }
}


export function PriceFormatter1(val) {
    if(val == undefined)
    return(
        "$0"
    )
    else{
    let str =  accounting.formatMoney(val);
    str=str.slice(0,-3);
    return (
        str
    )
    }
}

export function PercentFormatter(cell, row) {
    if(cell != 0.0)  {
        return Number((cell)/ 100).toLocaleString('en-US', {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    } 
    else if(cell == 0.0){ 
          return '0.0%'
    }

    else  {
        return '';
    }
}

export function PercentFormatter1(val) {
    if(val) {
        return Number((val)/ 100).toLocaleString('en-US', {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    } 
    else if(val == 0.0){ 
        return '0.0%'
  }

    else  {
        return '';
    }
}

export function DateFormatter(cell, row) {
    if(cell) {
        return new Date(cell).toLocaleDateString('en-US');
    } else  {
        return '';
    }
}

export function VirtualizedPriceFormatter(cell, row) {
    if(cell.cellData == undefined)
    return(
        "$0"
    )
    else{
    let str =  accounting.formatMoney(cell.cellData);
    str=str.slice(0,-3);
    return (
        str
    )
    }
}

export function differenceFormatter (cell, rows) {

    let volumeGap = _get(rows, 'gapAmount', 0);
    let str =  accounting.formatMoney(volumeGap);
    str=str.slice(0,-3);
    if(volumeGap>0){
        return (
            <div className={"greenText"}>{str}</div>
        )
    }
    else if(volumeGap<=0){
        return (
            <div className={"redText"}>{str}</div>
        )
    }
  }

  export function differenceFormatter1(val) {

    let str =  accounting.formatMoney(val);
    str=str.slice(0,-3);
    if(str>0){
        return (
            <div className={"greenText"}>{str}</div>
        )
    }
    else if(str<=0){
        return (
            <div className={"redText"}>{str}</div>
        )
    }
  }

  export function VirtualizedDifferenceFormatter (cell, rows) {

    let volumeGap = _get(cell, 'cellData', 0);
    let str =  accounting.formatMoney(volumeGap);
    str=str.slice(0,-3);
    if(volumeGap>0){
        return (
            <div className={"greenText"}>{str}</div>
        )
    }
    else if(volumeGap<=0){
        return (
            <div className={"redText"}>{str}</div>
        )
    }
  }
  export function escapeDoubleQuotes(params) {
   // return params.replace(/\\([\s\S])|(")/g,"\\$1$2"); 
     params= params.replaceAll("\"(.+)\"", "$1");
    return params;
}
// export const convertArrayToObject = (array, key) => 
//   array.reduce((acc, curr) =>(acc[params[key]] = params, acc), {});

export function jsonToParam(params,startWith){
    if(params){
        let paramArr = [];
        Object.keys(params).forEach(function(key){
            if(typeof params[key]!= 'object')
            paramArr.push(encodeURIComponent(key)+'='+encodeURIComponent(params[key]));
            if(typeof params[key] == 'object')
            paramArr.push(encodeURIComponent(key)+'='+encodeURIComponent(params[key]));
        });
        return startWith ?startWith +paramArr.join('&'):paramArr.join('&');
    }
    else{
        return '';
    }
}

export function paramsToJSON(params) {
    if(params.indexOf('?') > -1){
        params = params.split('?')[1];
    }
    var pairs = params.split('&');
    var result = {};
    pairs.forEach(function(pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return result;
  }

  export function paramsToJSON1(params) {
    // setTimeout(function() { 
    if(params.toString().indexOf('?') > -1){
        params = params.toString().split('?')[1];
    }
    var pairs = params.toString().split('&');
    var result = {};
    pairs.forEach(function(pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return result;
// }.bind(this), 1000)
  }
  export function jsonToParam1(params,startWith){
    if(params){
        let paramArr = [];
        Object.keys(params).forEach(function(key){
            if(typeof params[key]!= 'object')
            paramArr.push(encodeURIComponent(key)+'='+encodeURIComponent(params[key]));
            if(typeof params[key] == 'object')
            paramArr.push(encodeURIComponent(key)+'='+encodeURIComponent(params[key]));
        });
        return startWith ?startWith +paramArr.join('&'):paramArr.join('&');
    }
    else{
        return '';
    }
}
export function dynamicDateFilters (params) {
    let date = new Date();
      let month = date.getMonth();
      let monthValue = month;
      params.month = monthValue.toString();
      let year = date.getFullYear();
      let yearString = year.toString();
     // params.year = yearString;
     params.year = 2022;
      if(month >= 1 && month <= 3){
          params.quarter= 1
      }
      else if(month >= 4 && month <= 6){
          params.quarter = 2
      }
      else if(month >= 7 && month <= 9){
          params.quarter = 3
      }
      else if(month >= 10 && month <= 12){
          params.quarter = 4
      }
      return params;
}

// Just for defulation year filter to 2020 in corporate 
export function dynamicDateFilters1 (params) {
    let date = new Date();
      let month = date.getMonth();
      let monthValue = month;
      params.month = monthValue.toString();
      let year = date.getFullYear();
      let yearString = year.toString();
     // params.year = yearString;
     params.year = 2022;
      if(month >= 1 && month <= 3){
          params.quarter= 1
      }
      else if(month >= 4 && month <= 6){
          params.quarter = 2
      }
      else if(month >= 7 && month <= 9){
          params.quarter = 3
      }
      else if(month >= 10 && month <= 12){
          params.quarter = 4
      }
      return params;
}

  export function monthName(month) {
      let title = "";
      switch (month) {
          case "1" :
              title = 'Jan';
              break;
          case "2" :
              title = 'Feb';
              break;
          case "3" :
              title = 'Mar';
              break;
          case "4" :
              title = 'Apr';
              break;
          case "5" :
              title = 'May';
              break;
          case "6" :
              title = 'Jun';
              break;
          case "7" :
              title = 'Jul';
              break;
          case "8" :
              title = 'Aug';
              break;
          case "9" :
              title = 'Sep';
              break;
          case "10" :
              title = 'Oct';
              break;
          case "11":
              title = 'Nov';
              break;
          case "12" :
              title = 'Dec';
              break;
  
          default:
              title = month;
      }
      return title;
  }
  export function monthName1(month) {
    let title = "";
    switch (month) {
        case 1 :
            title = 'Jan';
            break;
        case 2 :
            title = 'Feb';
            break;
        case 3 :
            title = 'Mar';
            break;
        case 4 :
            title = 'Apr';
            break;
        case 5 :
            title = 'May';
            break;
        case 6 :
            title = 'Jun';
            break;
        case 7 :
            title = 'Jul';
            break;
        case 8 :
            title = 'Aug';
            break;
        case 9 :
            title = 'Sep';
            break;
        case 10 :
            title = 'Oct';
            break;
        case 11:
            title = 'Nov';
            break;
        case 12 :
            title = 'Dec';
            break;

        default:
            title = month;
    }
    return title;
}

